/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Current_Event_TooltipInputs */

const en_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The current event active on screen`)
};

const fr_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evenement actuellement actif a l'ecran`)
};

const de_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das aktuelle Ereignis, das auf dem Bildschirm angezeigt wird`)
};

const it_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento corrente attivo sullo schermo`)
};

const ru_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущее событие, активное на экране.`)
};

const es_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento actual activo en la pantalla`)
};

const zh_cn2_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屏幕上正在发生的事件`)
};

const ja_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面上で現在アクティブなイベント`)
};

const hi_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रीन पर वर्तमान में सक्रिय इवेंट`)
};

const pt_pt2_timing_sync_current_event_tooltip = /** @type {(inputs: Timing_Sync_Current_Event_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento atual está ativo na tela.`)
};

/**
* | output |
* | --- |
* | "The current event active on screen" |
*
* @param {Timing_Sync_Current_Event_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_current_event_tooltip = /** @type {((inputs?: Timing_Sync_Current_Event_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Current_Event_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_current_event_tooltip(inputs)
	if (locale === "de") return de_timing_sync_current_event_tooltip(inputs)
	if (locale === "it") return it_timing_sync_current_event_tooltip(inputs)
	if (locale === "ru") return ru_timing_sync_current_event_tooltip(inputs)
	if (locale === "es") return es_timing_sync_current_event_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_current_event_tooltip(inputs)
	if (locale === "ja") return ja_timing_sync_current_event_tooltip(inputs)
	if (locale === "hi") return hi_timing_sync_current_event_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_current_event_tooltip(inputs)
	return en_timing_sync_current_event_tooltip(inputs)
});